import { connect } from 'react-redux';
import Settings from './Settings';

const mapStateToProps = ({ user, currentOrganisation }) => ({
  user,
  currentOrganisation,
});

const mapDispatchToProps = () => ({});

const SettingsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Settings);

export default SettingsContainer;



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsContainer.js